import { render } from "./LinksAndMedia.vue?vue&type=template&id=3b4e1f3a&scoped=true"
import script from "./LinksAndMedia.vue?vue&type=script&lang=js"
export * from "./LinksAndMedia.vue?vue&type=script&lang=js"

import "./LinksAndMedia.vue?vue&type=style&index=0&id=3b4e1f3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4e1f3a"]])

export default __exports__